import type SimpleDate from 'app/common/classes/simple-date'

import styles from './SurveysTablePeriod.module.scss'

const dateFormat = 'DD.MM.YYYY'

const formatDate = (date: SimpleDate | null) => date?.getStringFormatted(dateFormat) || ''

type Props = {
  dateFrom: SimpleDate | null
  dateTo: SimpleDate | null
}

export const SurveysTablePeriod = ({ dateFrom, dateTo }: Props) => (
  <>
    <span className={styles.date}>{`с ${formatDate(dateFrom)}`}</span>
    <span className={styles.date}>{`по ${formatDate(dateTo)}`}</span>
  </>
)
